<template>
    <NavMenu />
  <section class="border-t">
    <div class="bg-brand-blue py-8 px-5">
      <div class="max-w-7xl mx-auto">
        <div class="text-white">
          <div class="">
            <div class="text-sm font-bold text-gray-200 mb-5">Home / {{ page.title }}</div>
            <h1 class="text-3xl font-bold">{{ page.title }}</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="py-20">
      <div class="max-w-7xl mx-auto">
        <div>
          <div class="" v-html="page.content">
          </div>
        </div>
      </div>
    </div>
  </section>
  <SectionFooter />
</template>

<script setup>
import NavMenu from "@/components/NavMenu";
import SectionFooter from "@/components/SectionFooter";
import { useStore } from "vuex";
import { computed } from "@vue/runtime-core";
import { useRoute } from "vue-router";

const store = useStore();
const page = computed(() => store.getters["page/data"].row);
const route = useRoute();

store.dispatch("http/send", {
  module: "page",
  key: 'row',
  params: {
    slug: route.params.slug
  }
});
</script>